import { renderTemplate, SB } from '@play-co/replicant';
import {
  androidGenericTemplate,
  iosGenericTemplate,
} from '../messageTemplates';

export const systemChatbotMessage = renderTemplate({
  args: SB.string(),
  renderers: {
    line: ({ args }) => ({
      type: 'text',
      text: args,
    }),
    ios: ({ args, payload }) =>
      iosGenericTemplate({
        alert: args,
        payload,
      }),
    android: ({ args, payload }) =>
      androidGenericTemplate({
        title: args,
        payload,
      }),
  },
});
